import moment from 'moment'

export function constructCreateGoalPayload (goal, userId, convertedTarget, version) {
  let startTime = moment().startOf('week').format()

  if (goal.startTime === 'nextweek') {
    startTime = moment().endOf('week').add(1, 'd').format()
  }

  const goalTag = []

  if (goal.activity !== '') {
    goalTag.push(goal.activity)
  }

  return {
    user: `/v${version}/user/${userId}/`,
    start_datetime: startTime,
    period: 'P1W',
    _links: {
      privacy: [{
        href: `/v${version}/privacy_option/0/`,
        id: '0',
      }],
    },
    end_datetime: null,
    criteria: [
      {
        threshold_metrics: [
          [
            {
              operator: 'gte',
              data_type_field: goal.type,
              value: parseFloat(convertedTarget),
            },
          ],
        ],
        scope: 'sessions',
        tags: goalTag,
        includes_metrics: [
          {
            data_type_field: 'distance_summary.distance_sum',
          },
          {
            data_type_field: 'sessions_summary.sessions_duration_sum',
          },
          {
            data_type_field: 'sessions_summary.sessions_sum',
          },
          {
            data_type_field: 'energy_expended_summary.energy_expended_sum',
          },
        ],
      },
    ],
  }
}



// WEBPACK FOOTER //
// ./src/services/goals/helpers.js